



















import Vue from 'vue'
import { BaseCardTitle, BaseCardTitleBtnChange } from '@/components'
import { ContactData, ContactDataForm } from './components'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, MUTATIONS_ORDER } from '@/enums'
import { IStateOrder, IOrder } from '@/models'

const { mapState, mapMutations } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'OrderContactData',

    components: { BaseCardTitle, BaseCardTitleBtnChange, ContactData, ContactDataForm },

    props: {
        order: {
            type: Object as () => IOrder,
            required: true,
        },
    },

    data: () => ({
        isFormShown: false,
    }),

    computed: {
        ...(mapState(['shippingContactData']) as MapStateToComputed<IStateOrder>),
    },

    created() {
        this.setShippingContactData(this.order.defaultShippingContactData)
    },

    beforeDestroy() {
        this.setShippingContactData()
    },

    methods: {
        ...mapMutations({ setShippingContactData: MUTATIONS_ORDER.SET_SHIPPING_CONTACT_DATA }),
    },
})
